import { updateNotification } from './actions';
import { TThunkAction } from '../../types/redux';
import { INotificationState } from '../../types/redux/notificator';

const createNotificationSetter = () => {
  // типизация глючит, NodeJS.Timeout не работает, хотя должен
  /* oxlint-disable typescript/no-explicit-any */
  let timerId: any;

  return (partialNotificationData: Partial<INotificationState>): TThunkAction =>
    dispatch => {
      dispatch(updateNotification(partialNotificationData));

      if (timerId) {
        clearTimeout(timerId);
      }

      if (partialNotificationData.duration) {
        timerId = setTimeout(
          () => dispatch(updateNotification({ isOpen: false, duration: null })),
          partialNotificationData.duration,
        );
      }
    };
};

export const setNotification = createNotificationSetter();
